import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseServices } from "../incadea-interfaces/responses/ResponseServices.interface";
import { incadeaEnvironment } from "src/environments/environment";
@Injectable({
    providedIn: 'root',
  })
export class GetServicesService {

  
    constructor(private http: HttpClient,
       ) { 

        }
    public getServices(token:string,CompanyId:string,LocationId:string,Department:string, Make:string,backEndCode:string) {
      
        // Define el encabezado de la solicitud
        const headers = new HttpHeaders()
        .set('Accept-Language', 'en-US,en;q=0.9')
        .set('Authorization', `Bearer ${token}`)
        .set('backend-code', `${backEndCode}`);
        const url = new URL(`${incadeaEnvironment.departments}/${CompanyId}/services`);
        url.searchParams.append('LocationId', LocationId);
        url.searchParams.append('Department', Department);
        url.searchParams.append('Make', Make);
              
        // Realiza la solicitud POST
       return this.http.get<ResponseServices[]>(url.toString(), { headers })
      }
    }
  